module.exports = __webpack_public_path__ + "img/FlightInfoAdmin.dd3205b3.png";